// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SI219Py6mECJw4THtb_w {
    position: relative;
    display: flex;
}

@media screen and (max-width: 768px) {
    .SI219Py6mECJw4THtb_w {
        flex-direction: column;
        background-color: #F7F7F7;
    }

    .SI219Py6mECJw4THtb_w > section {
        width: 100%;
        max-width: unset;
        box-sizing: border-box;
    }
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/DashboardManager/DashboardManager.module.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI;QACI,sBAAsB;QACtB,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,sBAAsB;IAC1B;AACJ","sourcesContent":[".main {\n    position: relative;\n    display: flex;\n}\n\n@media screen and (max-width: 768px) {\n    .main {\n        flex-direction: column;\n        background-color: #F7F7F7;\n    }\n\n    .main > section {\n        width: 100%;\n        max-width: unset;\n        box-sizing: border-box;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `SI219Py6mECJw4THtb_w`
};
export default ___CSS_LOADER_EXPORT___;
